import { ChangeDetectorRef, Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { pushToDataLayer } from '@helpers/gtm.util';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { DepositFrameDialog } from '@components/deposit-frame-dialog';

@Component({
  selector: 'deposit-wettarena-comp',
  templateUrl: './deposit-wettarena.component.html',
})
export class DepositWettarenaComponent {
  // bet3000
  amount = 0;
  alertMessage = false;
  alertMessageDesc = '';
  withdrawList = [];
  paymentType: any;
  toggleTransfer: any;
  // bet300
  depositList = [];

  deposits;
  yourIDControl: string;
  addressControl: string;
  creditCardControl: string;
  otherControl: string;
  PEP: string;
  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    public _DataHelper: DataHelper,
    private domSanitizer: DomSanitizer,
    public dialog: MatDialog
  ) {}

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) {
      this._UiHelper.setRightMenu();
    }

    this._UiHelper.setNavbarTitle('Deposit', true);
    this.getUploadFilesControl();
    this.getInsicStatus();
    this._UserHelper.depositListListener.emit('init');
  }

  getUploadFilesControl() {
    this._ApiService.getUploadsFiles().then(controls => {
      ////// console.log("controls", controls);

      this.yourIDControl = controls.Document1Status;
      this.addressControl = controls.Document2Status;
      this.creditCardControl = controls.Document3Status;
      this.otherControl = controls.Document4Status;
      this.PEP = controls.PEPStatus;
    });
  }

  showDetail(e, DepositTypeId = 0) {
    // console.log('--DepositTypeId--',DepositTypeId);
    window.scroll(0, 0);
    //// console.log(e);
    if (e == 'depositcreditcard') {
      this._router.navigate(['/depositcreditcard', DepositTypeId]);
    } else if (e == 'coinbase') {
      this._router.navigate(['/depositcoin', DepositTypeId]);
    } else if (e == 'paydox') {
      this._router.navigate(['/depositpaydox', DepositTypeId]);
    } else if (e == 'paydox2') {
      this._router.navigate(['/depositpaydox2', DepositTypeId]);
    } else if (e == 'irgate') {
      this._router.navigate(['/depositirgate', DepositTypeId]);
    } else if (e == 'apcopay') {
      this._router.navigate(['/depositapco/0', DepositTypeId]);
    } else if (e == 'uberweisen') {
      this._router.navigate(['/depositou', 0, DepositTypeId]);
    } else if (e == 'sofort') {
      this._router.navigate(['/depositsofort', 0, DepositTypeId]);
    } else if (e == 'apcocashtocode') {
      this._router.navigate(['/depositcashtocode/3', DepositTypeId]);
    } else if (e == 'apcoecow') {
      this._router.navigate(['/depositapco/2', DepositTypeId]);
    } else if (e == 'apcomuch') {
      this._router.navigate(['/depositapco/1', DepositTypeId]);
    } else if (e == 'apcoicardvisa') {
      this._router.navigate(['/depositapco/4', DepositTypeId]);
    } else if (e == 'apcoicardmaster') {
      this._router.navigate(['/depositapco/4', DepositTypeId]);
    } else if (e == 'paypal') {
      this._router.navigate(['/depositpaypal/0', DepositTypeId]);
    } else if (e == 'depositskrill') {
      this._router.navigate(['/depositskrill/0', DepositTypeId]);
    } else if (e == 'depositneteller') {
      this._router.navigate(['/depositneteller/0', DepositTypeId]);
    }
  }

  getInsicStatus() {
    this._ApiService.getInsicStatus().then(res => {
      this._UserHelper.userInsicStatus = parseInt(res);
    });
  }

  wettArenaConfirmButton() {
    const depositInfo = this._UserHelper.depositList.filter(f => f.DepositTypeId == this.paymentType);
    if (depositInfo.length > 0) {
      if (this.amount < depositInfo[0].MinValue || this.amount > depositInfo[0].MaxValue) {
        this.alertMessage = !this.alertMessage;
        const translator = new TranslatePipe(this._LocalizationService);
        const t_message = translator.transform('errorcode21', null);

        this.alertMessageDesc = t_message;
        setTimeout(() => {
          this.alertMessage = !this.alertMessage;
        }, 5000);

        return;
      } else {
        this._UiHelper.setLoadingDialog(true);

        this._ApiService.depositLugasControl(this.amount, depositInfo[0].DepositTypeId, true).then(result => {
          this._UiHelper.setLoadingDialog(false);
          const translator = new TranslatePipe(this._LocalizationService);

          const apcoresult = JSON.parse(result);

          if (apcoresult.result == 'success') {
            //Apco
            if (
              depositInfo[0].DepositTypeId === 69 ||
              depositInfo[0].DepositTypeId === 70 ||
              depositInfo[0].DepositTypeId === 71 ||
              depositInfo[0].DepositTypeId === 72 ||
              depositInfo[0].DepositTypeId === 21
            ) {
              this._ApiService.depositApco(this.amount, depositInfo[0].DepositTypeId).then(result => {
                this._UiHelper.setLoadingDialog(false);
                const translator = new TranslatePipe(this._LocalizationService);

                const apcoresult = JSON.parse(result);

                const dialogRef = this.dialog.open(DepositFrameDialog, {
                  width: '800px',
                  height: '70%',
                  panelClass: 'transcationDialog',
                  data: {
                    depositurl: apcoresult.desc,
                  },
                });
                dialogRef.afterClosed().subscribe(result => {
                  // //console.log('The dialog was closed',result);
                  this._ApiService
                    .getClient()
                    .then(result => {
                      this._UserHelper.setUser(result);
                    })
                    .catch();
                });

                if (apcoresult.result == 'success') {
                  this._UiHelper.setLoadingDialog(true);
                } else {
                  this._UiHelper.errorSnackBar(apcoresult.desc, '');
                }
              });
              //Apco
            }
            //Sofort
            else if (depositInfo[0].DepositTypeId === 68) {
              this._ApiService.depositSofort(this.amount).then(result => {
                this._UiHelper.setLoadingDialog(false);
                const translator = new TranslatePipe(this._LocalizationService);
                const apcoresult = JSON.parse(result);

                // const dialogRef = this.dialog.open(DepositFrameDialog, {
                //   width: "800px",
                //   height: "70%",
                //   panelClass: "transcationDialog",
                //   data: {
                //     depositurl: apcoresult.desc,
                //   },
                // });
                // dialogRef.afterClosed().subscribe((result) => {
                //   // //console.log('The dialog was closed',result);
                //   this._ApiService
                //     .getClient()
                //     .then((result) => {
                //       this._UserHelper.setUser(result);
                //     })
                //     .catch();
                // });

                if (apcoresult.result == 'success') {
                  this._UiHelper.setLoadingDialog(true);
                  window.location = apcoresult.desc;
                } else {
                  this._UiHelper.errorSnackBar(apcoresult.desc, '');
                }
              });
            }
            //Paypal
            else if (depositInfo[0].DepositTypeId === 11) {
              this._ApiService.depositPaypal(this.amount).then(result => {
                this._UiHelper.setLoadingDialog(false);
                const translator = new TranslatePipe(this._LocalizationService);
                const apcoresult = JSON.parse(result);

                const dialogRef = this.dialog.open(DepositFrameDialog, {
                  width: '800px',
                  height: '70%',
                  panelClass: 'transcationDialog',
                  data: {
                    depositurl: apcoresult.desc,
                  },
                });
                dialogRef.afterClosed().subscribe(result => {
                  // //console.log('The dialog was closed',result);
                  this._ApiService
                    .getClient()
                    .then(result => {
                      this._UserHelper.setUser(result);
                    })
                    .catch();
                });

                if (apcoresult.result == 'success') {
                  this._UiHelper.setLoadingDialog(true);
                } else {
                  this._UiHelper.errorSnackBar(apcoresult.desc, '');
                }
              });
            }
            //Skrill
            else if (depositInfo[0].DepositTypeId === 74) {
              this._ApiService.depositSkrill(this.amount, depositInfo[0].DepositTypeId).then(result => {
                this._UiHelper.setLoadingDialog(false);
                const translator = new TranslatePipe(this._LocalizationService);
                const apcoresult = JSON.parse(result);

                const dialogRef = this.dialog.open(DepositFrameDialog, {
                  width: '800px',
                  height: '70%',
                  panelClass: 'transcationDialog',
                  data: {
                    depositurl: apcoresult.desc,
                  },
                });
                dialogRef.afterClosed().subscribe(result => {
                  // //console.log('The dialog was closed',result);
                  this._ApiService
                    .getClient()
                    .then(result => {
                      this._UserHelper.setUser(result);
                    })
                    .catch();
                });

                if (apcoresult.result == 'success') {
                  this._UiHelper.setLoadingDialog(true);
                } else {
                  this._UiHelper.errorSnackBar(apcoresult.desc, '');
                }
              });
            }
            //PaysafeCard
            else if (depositInfo[0].DepositTypeId === 91) {
              this._ApiService.depositPaysafeCard(this.amount, depositInfo[0].DepositTypeId).then(result => {
                this._UiHelper.setLoadingDialog(false);
                const translator = new TranslatePipe(this._LocalizationService);
                const apcoresult = JSON.parse(result);

                const dialogRef = this.dialog.open(DepositFrameDialog, {
                  width: '800px',
                  height: '70%',
                  panelClass: 'transcationDialog',
                  data: {
                    depositurl: apcoresult.desc,
                  },
                });
                dialogRef.afterClosed().subscribe(result => {
                  // //console.log('The dialog was closed',result);
                  this._ApiService
                    .getClient()
                    .then(result => {
                      this._UserHelper.setUser(result);
                    })
                    .catch();
                });

                if (apcoresult.result == 'success') {
                  this._UiHelper.setLoadingDialog(true);
                } else {
                  this._UiHelper.errorSnackBar(apcoresult.desc, '');
                }
              });
            }
            //OnlineUeber
            else if (depositInfo[0].DepositTypeId === 67) {
              this._ApiService.depositOnlineUeber(this.amount).then(result => {
                this._UiHelper.setLoadingDialog(false);
                const translator = new TranslatePipe(this._LocalizationService);
                const apcoresult = JSON.parse(result);

                const dialogRef = this.dialog.open(DepositFrameDialog, {
                  width: '800px',
                  height: '70%',
                  panelClass: 'transcationDialog',
                  data: {
                    depositurl: apcoresult.desc,
                  },
                });
                dialogRef.afterClosed().subscribe(result => {
                  // //console.log('The dialog was closed',result);
                  this._ApiService
                    .getClient()
                    .then(result => {
                      this._UserHelper.setUser(result);
                    })
                    .catch();
                });

                if (apcoresult.result == 'success') {
                  this._UiHelper.setLoadingDialog(true);
                } else {
                  this._UiHelper.errorSnackBar(apcoresult.desc, '');
                }
              });
            }
            //Neteller
            else if (depositInfo[0].DepositTypeId === 15) {
              this._ApiService.depositNeteller(this.amount, depositInfo[0].DepositTypeId).then(result => {
                this._UiHelper.setLoadingDialog(false);
                const translator = new TranslatePipe(this._LocalizationService);
                const apcoresult = JSON.parse(result);

                const dialogRef = this.dialog.open(DepositFrameDialog, {
                  width: '800px',
                  height: '70%',
                  panelClass: 'transcationDialog',
                  data: {
                    depositurl: apcoresult.desc,
                  },
                });
                dialogRef.afterClosed().subscribe(result => {
                  // //console.log('The dialog was closed',result);
                  this._ApiService
                    .getClient()
                    .then(result => {
                      this._UserHelper.setUser(result);
                    })
                    .catch();
                });

                if (apcoresult.result == 'success') {
                  this._UiHelper.setLoadingDialog(true);
                } else {
                  this._UiHelper.errorSnackBar(apcoresult.desc, '');
                }
              });
            }
            //Paylado
            else if (depositInfo[0].DepositTypeId === 85) {
              this._ApiService.depositPaylado(this.amount).then(result => {
                this._UiHelper.setLoadingDialog(false);
                const translator = new TranslatePipe(this._LocalizationService);

                const apcoresult = JSON.parse(result);

                const dialogRef = this.dialog.open(DepositFrameDialog, {
                  width: '100%',
                  height: '100%',
                  panelClass: 'transcationDialog-full-width',
                  data: {
                    depositurl: apcoresult.desc,
                  },
                });
                dialogRef.afterClosed().subscribe(result => {
                  // //console.log('The dialog was closed',result);
                  this._ApiService
                    .getClient()
                    .then(result => {
                      this._UserHelper.setUser(result);
                    })
                    .catch();
                });

                if (apcoresult.result == 'success') {
                  // this.firststep = false;
                  // this.iframesrc = this.domSanitizer.bypassSecurityTrustResourceUrl(apcoresult.desc);

                  this._UiHelper.setLoadingDialog(true);
                } else {
                  this._UiHelper.errorSnackBar(apcoresult.desc, '');
                }
              });
            }
            //Arenapay
            else if (depositInfo[0].DepositTypeId === 93) {
              let parameterType = 'DEBIT_CUSTOMER';

              this._ApiService.DepositWithdrawArenaPay(this.amount, parameterType).then(result => {
                this._UiHelper.setLoadingDialog(true);

                const translator = new TranslatePipe(this._LocalizationService);
                const apcoresult = JSON.parse(result);
                this._ApiService
                  .getClient()
                  .then(result => {
                    this._UserHelper.setUser(result);
                  })
                  .catch();
                if (apcoresult.Status == true) {
                  const info_message = translator.transform('arenaPayInfoMessage', null);
                  this._UiHelper.successSnackBar(info_message, '');
                } else {
                  this._UiHelper.errorSnackBar(apcoresult.ErrorMessage, '');
                }
                this._UiHelper.setLoadingDialog(false);
              });
            }
          } else if (apcoresult.result === 'errorLugas') {
            const t_message3 = translator.transform('errorcode20', null);

            this._UiHelper.errorSnackBarWithOpenAccountTab(t_message3, 'Click', 6);

            pushToDataLayer({
              event: 'deposit_failed',
              method: depositInfo[0].Description,
              amount: this.amount,
              currency: this._UserHelper.customerUser.Symbol,
            });
          } else {
            this._UiHelper.errorSnackBar(apcoresult.desc, '');
            pushToDataLayer({
              event: 'deposit_failed',
              method: depositInfo[0].Description,
              amount: this.amount,
              currency: this._UserHelper.customerUser.Symbol,
            });
          }
        });
      }
    } else {
      return;
    }
  }

  toggleBankTransfer() {
    this.toggleTransfer = !this.toggleTransfer;
  }

  copyClickBoard(text) {
    const translator = new TranslatePipe(this._LocalizationService);
    const t_message = translator.transform('Copied', null);
    this._UiHelper.errorSnackBar(t_message, '');
    navigator.clipboard.writeText(text).then(
      function () {
        console.log('Async: Copying to clipboard was successful!', text);
      },
      function (err) {
        console.error('Async: Could not copy text: ', err);
      }
    );
  }
  OpenAccountMobile(selectMenu) {
    this._UiHelper.b3000SetAcountMobileState('open', selectMenu);
    this._UiHelper.b3000SetRightMenuState('close');
  }
}
